<template>
  <div style="width: 100%; height: 100%;">
    <slot />

    <div class="management-section-wrapper" style="height: 100%;">
      <v-main
        id="scroll-target"
        style="height: 100%;"
        class="overflow-y-auto "
      >
        <v-data-table
          :headers="headers"
          :items="dataToShow"
          hide-default-header
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr>
              <td class="data-table-td border-right">
                {{ props.item.attribute }}
              </td>

              <td class="data-table-td">
                {{ props.item.value }}
                <md-tooltip
                  v-if="isTooBig(props.item.value)"
                  class="return-to-tooltip"
                  md-direction="right"
                >
                  {{ props.item.value }}
                </md-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-main>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailDataTable",

  props: {
    originalData: {
      type: Object,
      required: true
    },
    maxHeight: Number
  },

  data() {
    return {
      dataToShow: []
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$i18n.t("Attribute"), align: "left", value: "attribute" },
        { text: this.$i18n.tc("Value", 1), align: "left", value: "value" }
      ];
    }
  },

  watch: {
    originalData() {
      this.getTableData();
    }
  },

  mounted() {
    this.getTableData();
  },

  methods: {
    getTableData() {
      this.fillDataToShow().then(() => {
        this.$emit("resize-tab");
      });
    },

    fillDataToShow() {
      return new Promise(resolve => {
        this.dataToShow = [];
        Object.keys(this.originalData).forEach(key => {
          if (key !== "images") {
            this.dataToShow.push({
              attribute: key,
              value: this.originalData[key]
            });
          }
        });
        resolve();
      });
    },

    isTooBig(value) {
      let stringValue = "";
      if (!value) {
        return false;
      } else if (typeof value === "string") {
        stringValue = value;
      } else if (typeof value === "object") {
        stringValue = JSON.stringify(value);
      } else {
        stringValue = value.toString();
      }
      return stringValue.length > 50;
    }
  }
};
</script>

<style scoped>
.management-section-wrapper {
  border-radius: 0;
  padding: 5px 5px;
}

.data-table-td {
  line-height: 30px;
  height: 25px !important;
  text-align: left;
}

.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.return-to-tooltip {
  height: auto;
  color: var(--secondary-lighter);
  background-color: var(--primary-normal);
  margin-left: -10px;
  z-index: 100;
  max-width: 300px;
  word-break: break-all;
  white-space: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Molecules/DetailDataTable.vue